<div (click)="handleClick(isCollapsed.getValue())" class="header-container">
  <i
    class="fa"
    [ngClass]="{
      'fa-minus': !isCollapsed.getValue(),
      'fa-plus': isCollapsed.getValue()
    }"
  ></i>

  <span class="header-label">
    <ng-content></ng-content>
  </span>
</div>
